<a
  class="text-body-bold text-neutral-600 py-2 px-4 rounded-full cursor-pointer inline-block hover:bg-brand-0 hover:text-brand-primary hover:text-shadow transition-all"
  routerLinkActive="active"
  [routerLink]="routerRedirect"
>
  {{ text }}
</a>
